import { ItineraryService } from './../itinerary.service';
import { ActivatedRoute } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Itinerary } from "./../itineray.model";
import { Component, OnInit } from "@angular/core";
import { v4 as uuid } from "uuid";

@Component({
  selector: "app-itinerary-reservations-accomodations",
  templateUrl: "./itinerary-reservations-accomodations.component.html",
  styleUrls: ["./itinerary-reservations-accomodations.component.css"]
})
export class ItineraryReservationsAccomodationsComponent implements OnInit {
  constructor(private route: ActivatedRoute, private snackBar: MatSnackBar, public itineraryService: ItineraryService) { }

  itinerary: Itinerary;

  expanded: boolean[];

  ngOnInit() {
    this.itinerary = this.route.parent.parent.snapshot.data.itinerary;
    this.syncExpanded();
  }

  private syncExpanded(expandLast: boolean = false) {
    this.expanded = [];
    this.itinerary.reservations.accomodations.forEach(() => this.expanded.push(false));
    if (expandLast) {
      this.expanded[this.expanded.length - 1] = true;
    }
  }

  removeAccomodation($event, accomodation) {
    $event.stopPropagation();
    if (confirm("Vuoi veramente eliminare questo alloggio?")) {
      const idx = this.itinerary.reservations.accomodations.indexOf(
        accomodation
      );
      this.itinerary.reservations.accomodations.splice(idx, 1);
      this.snackBar
        .open("Alloggio eliminato", "Annulla", {
          duration: 4000
        })
        .onAction()
        .subscribe(() => {
          this.itinerary.reservations.accomodations.splice(
            idx,
            0,
            accomodation
          );
          this.snackBar.open(
            "L'alloggio che avevi eliminato è stato inserito nuovamente nella lista.",
            null,
            {
              duration: 4000
            }
          );
        });
      this.syncExpanded();
    }
  }

  addAccomodation() {
    this.itinerary.reservations.accomodations.push({
      id: uuid(),
      start: null,
      end: null,
      city: "",
      proposals: [{ name: "", description: "", stars: null, price: null, link: { longUrl: null, shortUrl: null }, image: null, type: null, favorite: true, place: null, partner: null }, { name: "", description: "", stars: null, price: null, link: { longUrl: null, shortUrl: null }, image: null, type: null, favorite: false, place: null, partner: null }, { name: "", description: "", stars: null, price: null, link: { longUrl: null, shortUrl: null }, image: null, type: null, favorite: false, place: null, partner: null }],
    });
    this.syncExpanded(true);
  }
}
